"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamingHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactUse = require("react-use");
var _reactUi = require("@100mslive/react-ui");
var _ParticipantList = require("./ParticipantList");
var _LeaveRoom = require("../LeaveRoom");
var _MetaActions = _interopRequireDefault(require("../MetaActions"));
var _HeaderComponents = require("./HeaderComponents");
var _StreamActions = require("./StreamActions");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StreamingHeader = function StreamingHeader(_ref) {
  var isPreview = _ref.isPreview;
  var isMobile = (0, _reactUse.useMedia)(_reactUi.config.media.md);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    justify: "between",
    align: "center",
    css: {
      position: "relative",
      height: "100%"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      align: "center",
      css: {
        position: "absolute",
        left: "$10"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_HeaderComponents.Logo, {}), isMobile && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
        align: "center",
        gap: 2,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LeaveRoom.LeaveRoom, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_StreamActions.LiveStatus, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_StreamActions.RecordingStatus, {})]
      }), !isPreview ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_HeaderComponents.SpeakerTag, {}) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      align: "center",
      css: {
        position: "absolute",
        right: "$10",
        gap: "$4"
      },
      children: [isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MetaActions["default"], {
        compact: true
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
        css: {
          gap: "$4"
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StreamActions.StreamActions, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ParticipantList.ParticipantCount, {})]
    })]
  });
};
exports.StreamingHeader = StreamingHeader;